import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api, setStoredToken } from "../lib/api";
import { useAuth } from "../lib/auth";
import { Loader2 } from "lucide-react";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { refresh } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    (async () => {
      const hash = window.location.hash || "";
      const params = new URLSearchParams(hash.replace(/^#/, ""));
      const session_id = params.get("session_id");
      if (!session_id) {
        navigate("/", { replace: true });
        return;
      }
      try {
        const { data } = await api.post("/auth/session", { session_id });
        if (data?.session_token) setStoredToken(data.session_token);
        window.history.replaceState({}, "", "/dashboard");
        await refresh();
        navigate("/dashboard", { replace: true });
      } catch (e) {
        console.error("Auth exchange failed", e);
        navigate("/", { replace: true });
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="min-h-screen bg-slate-50 text-slate-900 flex items-center justify-center" data-testid="auth-callback">
      <div className="text-center">
        <Loader2 className="w-8 h-8 text-[var(--brand-primary)] mx-auto animate-spin" />
        <div className="text-[11px] uppercase tracking-[0.18em] font-semibold text-slate-500 mt-5">Authenticating</div>
        <div className="font-heading text-lg font-semibold tracking-tight mt-1">Establishing secure session…</div>
      </div>
    </div>
  );
}
